import { Flex } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import CustomText from "components/ui/CustomText/CustomText";
import GroupButton, { ActionButton } from "components/ui/GroupButton/GroupButton";
import { SearchInput } from "components/ui/SearchInput/SearchInput";
import { CommonParamsType } from "constants/types/common";
import { FORM_IDS } from "pages/ProductCategory/config";
import { FC, useRef } from "react";
import { useSWRConfig } from "swr";
import { useAppModal } from "utils/hooks/ui/useAppModal";
import { getProductCategoryListKey } from "utils/hooks/request/useProductCategories";
import CreateForm from "../CreateForm/CreateForm";

type ProductCategoryActionsProps = {
  handleSearch: (value: string) => void;
  params: CommonParamsType;
};

const ProductCategoryActions: FC<ProductCategoryActionsProps> = ({
  handleSearch,
  params,
}) => {
  const { openCrudModal, closeCrudModal } = useAppModal();
  const { mutate } = useSWRConfig();
  const activeModalId = useRef<string | null>(null);

  const handleCloseModal = () => {
    if (activeModalId.current) {
      closeCrudModal(activeModalId.current);
      activeModalId.current = null;
    }
  };

  const handleOpenCreateModal = () => {
    const modalId = openCrudModal(
      <CustomText variant="section-title">Tạo mới nhóm mặt hàng</CustomText>,
      {
        mode: "create",
        formId: FORM_IDS.CREATE,
        children: (
          <CreateForm
            mutate={() => mutate(getProductCategoryListKey(params))}
            onClose={handleCloseModal}
          />
        ),
        submitText: "Tạo mới",
      },
      500,
    );
    activeModalId.current = modalId;
  };

  const actions: ActionButton[] = [
    {
      key: "create",
      label: "Tạo mới",
      icon: <IconPlus size={18} />,
      variant: "filled",
      color: "blue",
      isLoading: false,
      onClick: handleOpenCreateModal,
      permission: "product_category:create",
    },
  ];

  return (
    <Flex justify="space-between" align="center">
      <SearchInput
        value={params.search ?? ""}
        onChange={handleSearch}
        placeholder="Tìm kiếm nhóm mặt hàng"
      />
      <GroupButton actions={actions} />
    </Flex>
  );
};

export default ProductCategoryActions;
